import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/special-offers`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all special offers with pagination
export const fetchSpecialOffersTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all special offers
export const fetchSpecialOffers = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch a special offer by ID
export const fetchSpecialOfferById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new special offer
export const addSpecialOffer = async (newOffer: { name: string; description: string; price: number;  }) => {
  const response = await axios.post(API_URL, newOffer, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Edit an existing special offer
export const updateSpecialOffer = async (id: string, updatedOffer: { name: string; description: string; price: number; photo?: string }) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedOffer, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Delete a special offer
export const removeSpecialOffer = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
